@if (mode === 'short') {
  <div class="spinner-wrapper">
    <mat-spinner color="accent"></mat-spinner>
  </div>
} @else {
  <svg xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="100%"
    height="100%"
    viewBox="0 0 100 100"
    >
    <defs>
      <mask id="pd-gui-progress-symbol-mask-element">
        <image x="0"
          y="0"
          width="100"
          height="100"
          [attr.xlink:href]="progressMaskUrl" />
      </mask>
    </defs>

    <g mask="url(#pd-gui-progress-symbol-mask-element)"
       *ngIf="mode === 'indeterminate'">
      <rect x="0" y="0" width="100" height="100">
        <animate attributeName="opacity" values="1;0;1" dur="2s"
                 repeatCount="indefinite" />
      </rect>
    </g>
    <g mask="url(#pd-gui-progress-symbol-mask-element)"
       *ngIf="mode === 'determinate'">
      <rect x="0" y="0" style="transition: width 0.4s ease;"
            [attr.width]="filledWidth"
            height="100">
      </rect>
    </g>

    <image x="0"
      y="0"
      width="100"
      height="100"
      [attr.xlink:href]="progressMaskBorderUrl" />
  </svg>
}


